
import Stopper from '../assets/images/stopper.png';
const Products2 = [
  
  { id: 1, name: 'Rubber Stopper Damper', image: Stopper },

];

export default Products2;